import Header from './components/Header';
import Hero from './components/Hero';
import SectionUpdates from './components/SectionUpdates';
import SectionIndex from './components/SectionIndex';
import SectionComments from './components/SectionComments';
import SectionTopics from './components/SectionTopics';
import SectionCards from './components/SectionCards';
import SectionFeatures from './components/SectionFeatures';
import SectionCarousel from './components/SectionCarousel';
import SectionMedia from './components/SectionMedia';
import SectionApp from './components/SectionApp';
import SectionAbout from './components/SectionAbout';
import SectionContact from './components/SectionContact';
import SectionFaq from './components/SectionFaq';
import SectionRanking from './components/SectionRanking';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionUpdates />
        <SectionIndex />
        <SectionComments />
        <SectionTopics />
        <SectionCards />
        <SectionFeatures />
        <SectionCarousel />
        <SectionMedia />
        <SectionApp />
        <SectionAbout />
        <SectionContact />
        <SectionFaq />
        <SectionRanking />
      </main>
      <Footer />
    </>
  );
}